import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TenantContext = createContext(null);

export const TenantProvider = ({ children }) => {
  const { user } = useAuth();
  const [tenants, setTenants] = useState([]);
  const [tenantId, setTenantId] = useState(localStorage.getItem("mieruka_tenant") || "");

  const refreshTenants = useCallback(() => {
    if (!user) return;
    api.get("/tenants").then((r) => {
      setTenants(r.data);
      setTenantId((cur) => {
        const valid = r.data.find((t) => t.id === cur);
        const next = valid ? cur : (r.data[0]?.id || "");
        localStorage.setItem("mieruka_tenant", next);
        return next;
      });
    });
  }, [user]);

  useEffect(() => { refreshTenants(); }, [refreshTenants]);

  const switchTenant = (id) => {
    setTenantId(id);
    localStorage.setItem("mieruka_tenant", id);
  };

  const canSwitch = user && (["admin", "super_admin"].includes(user.role) || (user.tenant_ids || []).length > 1);
  const tenant = tenants.find((t) => t.id === tenantId) || null;
  return (
    <TenantContext.Provider value={{ tenants, tenantId, tenant, switchTenant, canSwitch, refreshTenants }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);
